import { render, staticRenderFns } from "./CompanyEditTabArchive.vue?vue&type=template&id=1ef2266d"
import script from "./CompanyEditTabArchive.vue?vue&type=script&lang=js"
export * from "./CompanyEditTabArchive.vue?vue&type=script&lang=js"
import style0 from "./CompanyEditTabArchive.vue?vue&type=style&index=0&id=1ef2266d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports